<template>
  <div class="footer">@2019 hadlinks.com   海大物联研发中心团队提供技术支持</div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.el-footer
  box-sizing border-box
  width 100%
  height 100%
  line-height 40px
  font-size 14px
  color #666
  background-color #fff
  box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
  text-align center
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue